import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../../components/Loading";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
/**
 * Interfaces
*/
import { Inputs } from "Interfaces/IAntiGlare";

interface ICreate {
  selectedUrlId: number | null;
  isOpenModalBraind: boolean;
  setModalClose: () => void;
  updateList: () => void;
}

export default function Update({
  isOpenModalBraind,
  setModalClose,
  updateList,
  selectedUrlId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {

      const response = await axiosInstance.get(
        `treatment/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }

    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(
        `treatment/${selectedUrlId}`,
        "PUT",
        data
      );
      if (response.status === 200) {
        alert("Antirreflexo atualizado com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o antirreflexo.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalBraind) {
    return (
      <LayoutWithList
        title="Atualizar Antirreflexo"
        subTitle="Atualize as informações do antirreflexo em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Antirreflexo
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o antirreflexo"
                  type="text"
                  {...register("treatment", { required: true })}
                />
                {errors.treatment && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
